import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaHome } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Helmet>
        <title>Tulvod - Ihr Experte fuer urbane Mobilitaet</title>
        <meta
          name="description"
          content="Tulvod - Entdecken Sie die besten Tipps, Routen und Informationen rund um Fahrradverleih und urbane Mobilitaet in Deutschland. Ihr Experte fuer Fahrradtouren und nachhaltige Fortbewegung."
        />
      </Helmet>

      <div className="contact-container">
        <div className="contact-header">
          <h1>Kontaktieren Sie uns</h1>
          <p>
            Haben Sie Fragen oder moechten Sie ein Fahrrad reservieren? Wir sind
            gerne fuer Sie da und helfen Ihnen weiter.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-form">
            <h2>Senden Sie uns eine Nachricht</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">Vorname</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Nachname</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-Mail</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Telefon</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Nachricht</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">
                Nachricht senden
              </button>
            </form>
          </div>

          <div className="contact-info">
            <h2>Kontaktinformationen</h2>
            <div className="info-item">
              <div className="info-icon">
                <FaHome />
              </div>
              <div className="info-content">
                <h3>Adresse</h3>
                <p>Ederring 7</p>
                <p>01775 Starnberg</p>
                <p>Deutschland</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">
                <FaPhone />
              </div>
              <div className="info-content">
                <h3>Telefon</h3>
                <p>
                  <a href="tel:+4990874455288">+49 908 744 552 88</a>
                </p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">
                <FaEnvelope />
              </div>
              <div className="info-content">
                <h3>E-Mail</h3>
                <p>
                  Email:{" "}
                  <a href="mailto:tulvod@hotmail.com">
                    tulvod@hotmail.com
                  </a>
                </p>
                <p>
                  <a href="https://wa.me/4990874455288">WhatsApp</a>
                </p>
                <p>
                  <a href="https://viber.me/4990874455288">Viber</a>
                </p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-content">
                <h3>Registrierungsnummer</h3>
                <p>21550582</p>
              </div>
            </div>
          </div>
        </div>

        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>Vielen Dank fuer Ihre Nachricht</h2>
              <p>
                Wir haben Ihre Anfrage erhalten und werden uns so schnell wie
                moeglich bei Ihnen melden. In der Regel antworten wir innerhalb
                von 24 Stunden.
              </p>
              <button onClick={closeModal} className="modal-close">
                Schliessen
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Contact;